import createStore from 'picostate';

const store = createStore({
  active: null,
  scrollDirection: 'DOWN',
  programmaticScroll: false
})

export default store